import { senecColors } from "src/styles/senecBaseThemePalette";

export const SenecTablePaginationTheme = {
    styleOverrides: {
        root: {
            fontFamily: "EnBW DIN Pro Medium, sans-serif",
            weight: "500",
            fontSize: "14px",
            lineHeight: "21px",

            "& .MuiTablePagination-input ": {
                padding: 0,
                overflow: "hidden",
            },
            "& .MuiTablePagination-toolbar ": {
                padding: 0,
                marginTop: "32px",
                minHeight: "unset",
            },
        },
        select: {
            fontFamily: "EnBW DIN Pro Medium, sans-serif",
            weight: "500",
            fontSize: "14px",
            lineHeight: "21px",
            display: "flex",
            alignItems: "center",
            paddingTop: "0px",
            paddingBottom: "0px",
            paddingLeft: "12px",
            height: "40px !important",
            maxHeight: "40px !important",
            paddingRight: "40px !important",

            "&:hover": {
                backgroundColor: senecColors.neutralGray05,
            },
        },
        displayedRows: {
            fontFamily: "EnBW DIN Pro Medium, sans-serif",
            weight: "500",
            fontSize: "14px !important",
            lineHeight: "21px",
            margin: "0px",
        },
        selectLabel: {
            fontFamily: "EnBW DIN Pro Medium, sans-serif",
            weight: "500",
            fontSize: "14px !important",
            lineHeight: "21px",
            margin: "0px",
        },
        input: {
            marginRight: "12px",
            height: "40px",
        },
    },
};
